/** Shared marketing copy for public client pages. */
export const INJURY_INSURANCE = {
  amount: 'Rs. 5 lakh',
  headline: 'Rs. 5 lakh injury insurance',
  shortLine: 'Included with every membership',
  description:
    'Sports injury cover while you play at The Sports Hub — included with every membership plan.',
  benefit: 'Rs. 5 lakh injury insurance included',
} as const;
